import React, { useState, useEffect } from 'react';
import './ProgressCircleDiseño2.css';
import iconLogo from '../images/Logo.png'; // Asegúrate que la ruta sea correcta

const ProgressCircle2 = ({ progress, secondaryProgress,coins,coinsComprados,diasRestantes }) => {
  const [offset, setOffset] = useState(0);
  const [offset2, setOffset2] = useState(0);
  const circumference = 2 * Math.PI * 130;
  const circumference2 = 2 * Math.PI *111;

  useEffect(() => {
    const progressOffset = circumference - (progress / 100) * circumference;
    const progressOffset2 = circumference2 - (secondaryProgress / 100) * circumference2;
    setOffset2(progressOffset2);
    setOffset(progressOffset);
    console.log(progressOffset2);
    console.log(progressOffset);
  }, [progress, secondaryProgress, circumference, circumference2]);

  const circleProgressStyle = {
    strokeDashoffset: offset,
    display: progress <= 0 ? 'none' : 'block',
    strokeWidth: '20px',
  };
  const circleProgressStyle2 = {
    strokeDashoffset: offset2,
    display: secondaryProgress <= 0 ? 'none' : 'block',
    strokeWidth: '20px',
  };

  return (
    <div className="circular-progress">
      <svg>
        <circle cx="100" cy="100" r="90" className="circle-bg" />
        <circle cx="80" cy="80" r="111" className="circle-bg2" />
        <circle cx="100" cy="100" r="90" className="circle-progress" style={circleProgressStyle} />
        <circle cx="80" cy="80" r="111" className="circle-progress2" style={circleProgressStyle2} />
      </svg>
      <div className="progress-content">
      {/*<img src={iconLogo} alt="Logo" className="logo-center" style={{ opacity: 0.5, position: 'absolute' }} />*/}
      {
       
      }
      <span className="progress-text"><h1>{coins} Coins</h1>  De {coinsComprados} <br></br>{secondaryProgress > 0 && <p className="vigenciaText">*Vigencia {diasRestantes} días</p>}</span>
      </div>
    </div>
  );
};

export default ProgressCircle2;
